module.exports = __webpack_public_path__ + "c5aebd8927c46704e6407078df183b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/1/Assets/day2&day3.png
// module id = 1353
// module chunks = 0